import { Provider } from '@angular/core';

import { PersonalDataRepositoryImpl } from '@app/data/repositories/personal-data/personal-data.repository';
import { PERSONAL_DATA_REPOSITORY } from '@app/domain/repositories/personal-data/personal-data.repository.contract';

export const personalDataRepositoryProvider: Provider = {
  provide: PERSONAL_DATA_REPOSITORY,
  useClass: PersonalDataRepositoryImpl
};
